import '../modules/consultationForm';

function restructureMenuWithTooManyItems() {

  const parent = document.querySelector('.countries-menu');

  if (parent) {
    const innerWrapper = parent.querySelector('.inner-box');
    const countriesDropdown = parent.querySelector('.inner-box .dropdown');
    const dropdownBtn = countriesDropdown.querySelector('.dropdown-btn');
    const dropdownContainer = countriesDropdown.querySelector('ul');
    const countries = Array.from(parent.querySelectorAll('.inner-box>a'));
    let parentWidth = parent.offsetWidth - 40;
    let currentWidth = 0;

    if (parentWidth < innerWrapper.offsetWidth) {

      countriesDropdown.style.display = 'initial';
      currentWidth += dropdownBtn.offsetWidth;

      countries.forEach(country => {

        currentWidth += country.offsetWidth;

        if (parentWidth < currentWidth) {
          let listEl = document.createElement('li');
          listEl.append(country);
          dropdownContainer.append(listEl);
        }
      });
    }
  }
}


document.addEventListener('DOMContentLoaded', (e) => {

  restructureMenuWithTooManyItems();

})